var searchedTerm;
var lastSearchedTerm = '';

const COVEO_SEARCH_SUGGESTIONS_MIN_LENGTH = 1;
const KEY_RECENT_SEARCHES = 'recentSearches';

const $autocompleteContainer = $(".autocomplete--result--container");
$(document).ready(function () {
    if (typeof autocompleteSearchProductsUrl !== 'undefined') {
        let $input = $('#header--search--input');
        if (!$input.length) {
            return false;
        }

        createAutocompleteDropdown($input, '#header-search-autocomplete-result');
        bindNavigationEvents($('#header--search--input, .autocompleteSuggestions'), $input,
            '#header-search-autocomplete-result',
            '.mm__search, .mm__search *',
            'autocomplete');

        $('#headerSearchForm [data-input-clear=""]').click(function () {
            var $parentForm = $(this).closest('form');
            var $resultContainer = $parentForm.find('.autocomplete--result--container');
            showDefaultSuggestions($resultContainer);
            lastSearchedTerm = '';
        });

        $(document).on('click', '.autocomplete--result--container ul.autocompleteSuggestions:not(.default-suggestion-list) a', function () {
            let productsTypedAndSuggested = this.innerText + ' | ' + searchedTerm;
            _push_event_to_google('ecom catalog - navigation and filters', 'search autocomplete - suggestion terms click', productsTypedAndSuggested);
            addSearchToRecentSearches(this.innerText);
        });

        $(document).on('click', '.autocomplete--result--container a.search--see-all', function () {
            _push_event_to_google('ecom catalog - navigation and filters', 'search autocomplete - view all product click', searchedTerm);
        });

        $(document).on('click', '.autocomplete--result--container ul.autocompleteSuggestions.default-suggestion-list a', function () {
            _push_event_to_google('ecom catalog - navigation and filters', 'search most popular', this.innerText);
        });
    }

    let $inputTrigger = $('#header--search--input');
    let $inputTriggerContainer = $('#headerSearchForm');
    // Limit the number of characters for searches
    const maxLength = typeof maxQueryLength === 'number' ? maxQueryLength : 50;
    if (maxLength !== -1 && $inputTrigger && $inputTrigger.length > 0) {
        $inputTrigger.on('input', function () {
            const value = $(this).val() || '';
            if (value.length > maxLength) {
                $(this).val(value.substring(0, maxLength));
                $('.search--btn').prop('disabled', true).addClass('disabled');
            } else if (value.length === 0) {
                $('.search--btn').prop('disabled', true).addClass('disabled');
            } else {
                $('.search--btn').prop('disabled', false).removeClass('disabled');
            }
        });
    }

    $inputTrigger.on('focus', function () {
        $('.search__overlay').addClass('d-flex');
        setTimeout(() => {
            $inputTrigger.addClass('writing');
            if (lang == 'en') {
                $inputTrigger.attr('placeholder', 'E,g. banana');
            } else {
                $inputTrigger.attr('placeholder', 'Ex: banane');
            }

            //close burger menu if open
            if ($('.mobile--menu.active').length) {
                mainMenuNav.closeMenuNav();
            }
            //$('.search--btn').show();
        }, 200);

    });
    $inputTriggerContainer.on('focusout', function () {
        $inputTrigger.removeClass('writing');
        setTimeout(function () {
            //$('.search--btn').hide();
        }, 200);

        $inputTrigger.attr('placeholder', $('.search__overlay-container label').text());
    });
    $inputTrigger.attr('disabled', false);
    $('header.metro-menu').removeClass('in-progress');

    let isSubmitting = false; // to prevent multiple submits
    $('#headerSearchForm').submit("submit", function (e) {
        if (isSubmitting) {
            e.preventDefault();
            return false;
        }

        isSubmitting = true;
        let searchValue = $('#header--search--input, #sticky-header--search--input').val();
        addSearchToRecentSearches(searchValue);
    });

    $(document).one('click', '#header-search-autocomplete-result li.one-click a', function () {
        $(this).css("pointer-events", 'none');
    });
});

function addSearchToRecentSearches(searchValue) {
    if (!isAuthenticated) {
        if (!searchValue || searchValue.length > 50) {
            return;
        }

        let nbSearches = 0;
        let recentSearches = localStorage.getItem(KEY_RECENT_SEARCHES);
        let arrRecentSearches = [];
        if (recentSearches) {
            arrRecentSearches = recentSearches.split("|");

            // Verify if terms already exists
            let found = arrRecentSearches.find((element) => element.trim() === searchValue.trim());
            if (found) {
                return;
            }

            nbSearches = arrRecentSearches.length;
            if (nbSearches > 2) {
                nbSearches = 2;
            }
        }

        // Save a new search among others
        for (let i = nbSearches; (i > 0); i--) {
            arrRecentSearches[i] = arrRecentSearches[i - 1];
        }
        arrRecentSearches[0] = searchValue;

        // Store recent searches
        let recentSearchesToStore = arrRecentSearches.join('|');
        localStorage.setItem("recentSearches", recentSearchesToStore);
    }
}

function createAutocompleteDropdown($input, searchAutocompleteResultDiv) {
    let minLength = autocompleteSearchProductsMinLength !== 'undefined' ? autocompleteSearchProductsMinLength : 3;
    if (typeof isCoveoEnabled !== 'undefined' && isCoveoEnabled) {
        minLength = COVEO_SEARCH_SUGGESTIONS_MIN_LENGTH;
    }
    let requestDelay = autocompleteSearchProductsRequestDelay !== 'undefined' ? autocompleteSearchProductsRequestDelay : 500;
    $input.autocomplete({
        source: function (request) {
            let term = request.term.trim();
            if (term.length >= minLength && lastSearchedTerm.trim() !== term) {
                searchedTerm = term;
                let previousSuggestion = '';
                if ($('#col-suggestion').attr("data-previous-suggestion")) {
                    previousSuggestion = $('#col-suggestion').attr("data-previous-suggestion");
                }

                pushHotJarEvent('metroAutocompleteSearch');
                $.ajax({
                    url: autocompleteSearchProductsUrl + '?freeText=' + encodeURIComponent(request.term.trim()) + '&tabletMobile=' + TINK.matchMediaMobileTablet() + '&previousSuggestion=' + encodeURIComponent(previousSuggestion),
                    type: 'post',
                    contentType: 'application/json',
                    success: function (data, code, jqXHR) {
                        let favoriteBanner = $('.choose-favorite-banner-sticky');
                        if (favoriteBanner.length && !favoriteBanner.hasClass('hide')) {
                            favoriteBanner.addClass('hide');
                        }

                        if (!!jqXHR.getResponseHeader('usePreviousSuggestion')) {
                            $('.autocompleteSuggestions').empty();
                            createAutocompleteSuggestions(data.freeTextSplitted, data.autocompleteSuggestions);
                        } else {
                            $(searchAutocompleteResultDiv).empty();
                            $(searchAutocompleteResultDiv).append($(data));
                            $(searchAutocompleteResultDiv).show();

                            if (productsAutocompleteEmpty) {
                                pushHotJarEvent('metroAutocompleteSearchNoProduct');
                                $('#col-produits').hide();
                                $('#col-suggestion').addClass('result-no-products');
                                $('.mobile-scroll-suggestion').css('height', 'auto');
                            }
                            if (autocompleteSuggestionsEmpty) {
                                pushHotJarEvent('metroAutocompleteSearchNoSuggestion');
                            }
                            if (productsAutocompleteEmpty && autocompleteSuggestionsEmpty) {
                                showDefaultSuggestions($(searchAutocompleteResultDiv));
                            }
                            if (!productsAutocompleteEmpty && !autocompleteSuggestionsEmpty) {
                                $('#col-suggestion').attr("data-previous-suggestion", autocompleteSuggestions[0]);
                            }

                            let searchResultContainer = document.getElementById('searchResultContainer');

                            if (searchResultContainer) {
                                searchResultContainer.scrollIntoView({ behavior:'auto', block: 'start', inline: 'nearest'})
                            }

                            updateQtyIncrementerButtonsState();
                            UAEvents.defineDocument('.autocomplete--result--container .tile-product', false);
                            UAEvents.defineDocumentClick('.autocomplete--result--container .tile-recepe', '.default-recipe-tile', 'recipe', false);
                            createAutocompleteSuggestions(freeTextSplitted, autocompleteSuggestions);
                        }
                    },
                    error: function (jqXHR, status, error) {
                        if (!TINK.redirectIfConflict(jqXHR)) {
                            console.warn('Error while trying to autocomplete search for ' + request.term + ' | error=' + error);
                        }
                    }
                });
            } else if (term.length < minLength) {
                showDefaultSuggestions($(searchAutocompleteResultDiv));
            }
            lastSearchedTerm = term;
        },
        minLength: 0,
        delay: requestDelay
    }).focus(function () {
        let inputValue = $input.val();
        if (inputValue === 'undefined' || inputValue.trim().length < minLength) {
            showDefaultSuggestions($(searchAutocompleteResultDiv));
        }
        if ($(".suggestions__wrapper").children().length && $autocompleteContainer.hasClass("hide")) {
            $autocompleteContainer.removeClass("hide");
        }
    });

    // If in mobile and a shorter placeholder exists, we have to replace the long one by the short one.
    if (Revealizr.isMobileDevice && $input.data('short-placeholder')) {
        $input.attr('placeholder', $input.data('short-placeholder'));
    }
}

function triggerHideAutocomplete(searchAutocompleteResultDiv) {
    emptyAndHideAutocompleteResults(searchAutocompleteResultDiv);
    $('.search__overlay').removeClass('d-flex');
    //$('.search--btn').hide();
    $('#header--search--input').val('');
}

function bindNavigationEvents(NavigationDivs, input, searchAutocompleteResultDiv, containerDivId, namespace) {
    $(window).on('mousedown.' + namespace, function (event) {
        if (!$(event.target).is(containerDivId)) {
            triggerHideAutocomplete(searchAutocompleteResultDiv);
        }
    });
    $(window).on('keydown.' + namespace, function (event) {
        let autocompleteModalActive = $('#header-search-autocomplete-result').attr('aria-hidden');

        if ($(event.target).is($('.input-close'))) {
            if (!event.shiftKey && (event.key === 'Tab' || event.keyCode === 9)) {
                TINK.trapFocus($('.autocomplete--result--div'));
            }
        } else if  ((event.key === 'Escape' || event.key === 'Esc') && autocompleteModalActive) {
            triggerHideAutocomplete(searchAutocompleteResultDiv);
            $('#header--search--input').focus();
        }
    });
}

function emptyAndHideAutocompleteResults(searchAutocompleteResultDiv) {
    var $searchAutocompleteResultDiv = $(searchAutocompleteResultDiv);
    if ($searchAutocompleteResultDiv.css('display') !== 'none') {
        handleBodyScroll(false);

        $searchAutocompleteResultDiv.empty();
        $searchAutocompleteResultDiv.hide().attr('aria-hidden', true);

        if(TINK.matchMediaMobileTablet()) {
            $('.mm__open-menu').removeClass('hide');
            $('.mm__logo').removeClass('hide');
            $('.user--container').removeClass('hide');
        }

        lastSearchedTerm = '';

        let favoriteBanner = $('.choose-favorite-banner-sticky');
        if (favoriteBanner.length && favoriteBanner.hasClass('hide')) {
            favoriteBanner.removeClass('hide');
        }
    }
}

function handleBodyScroll(blockScroll) {
    document.body.classList.toggle('noscroll-autocomplete', blockScroll);
    const autocompleteResultDiv = document.querySelector('.autocomplete--result--div');
    if (autocompleteResultDiv) {
        autocompleteResultDiv.scrollTop = 0;
    }
}

function showDefaultSuggestions($searchAutocompleteResultDiv) {
    $searchAutocompleteResultDiv.empty();

    if (autocompleteDefaultSuggestions) {
        var $suggestions_wrapper = $('<div class="suggestions__wrapper" />');
        var $advise_wrapper = $('#autocompleteBanner').clone();
        var $suggestions_header = $('<h3 class="search-proposition-subtitle recent-search" />');
        var $suggestions_ul = $('<ul class="autocompleteSuggestions ml-null default-suggestion-list"/>');
        var $trending_header = $('<h3 class="search-proposition-subtitle trending-search d-none d-md-flex">Trending now</h3>');
        var $trending_ul = $('<ul class="autocompleteSuggestions ml-null default-suggestion-list d-none d-md-block"/>');

        if(TINK.matchMediaMobileTablet()) {
            $('.mm__open-menu').addClass('hide');
            $('.mm__logo').addClass('hide');
            $('.user--container').addClass('hide');
        }

        $trending_header.html(autocompleteDefaultSuggestions.header);

        //Add recent searches
        let recentSearches = '';
        if (isAuthenticated) {
            $.ajax({
                url: productSearchHistoryUrl,
                type: 'GET',
                contentType: 'application/json',
                success: function (data) {
                    recentSearches = data;
                    getSearchHistory(recentSearches, $suggestions_header, $suggestions_wrapper, $suggestions_ul, $trending_ul, $trending_header, $advise_wrapper, $searchAutocompleteResultDiv);
                },
                error: function (jqXHR, status, error) {
                    if (!TINK.redirectIfConflict(jqXHR)) {
                        console.warn('Error while trying to get products search history for ' + request.term + ' | error=' + error);
                    }
                }
            });
        } else {
            recentSearches = localStorage.getItem("recentSearches");
            getSearchHistory(recentSearches, $suggestions_header, $suggestions_wrapper, $suggestions_ul, $trending_ul, $trending_header, $advise_wrapper, $searchAutocompleteResultDiv);
        }
    }
}

function getSearchHistory(recentSearches, $suggestions_header, $suggestions_wrapper, $suggestions_ul, $trending_ul, $trending_header, $advise_wrapper, $searchAutocompleteResultDiv) {
    if (recentSearches) {
        let arrRecentSearches = recentSearches.split("|");
        let nbSearches = arrRecentSearches.length;

        // Fix limit
        if (nbSearches > 3) {
            nbSearches = 3;
        }

        // Add recent searches title if needed
        if (nbSearches > 0) {
            $suggestions_header.html(autocompleteDefaultSuggestions.recentSearchesHeader);
            $suggestions_wrapper.append($suggestions_header);
        }

        for (let i = 0; (i < nbSearches); i++) {
            let searchHref = searchProductUrl + encodeURI(arrRecentSearches[i]);

            let liTag = '<li' + (i > 7 ? ' class="d-none d-md-block"' : '') + '/>';
            let $suggestion_li = $(liTag).append(
                $('<a/>', {
                    href: searchHref,
                    tabindex: 1,
                    one: {
                        click: function () {
                            $(this).css("pointer-events", 'none');
                        }
                    }
                }).html(arrRecentSearches[i])
            );
            $suggestions_ul.append($suggestion_li);
        }

        if (nbSearches > 0) {
            let liTag = '<li style="text-decoration: underline" class="clear-element" />';
            let $suggestion_li = $(liTag).append(
                $('<a/>', {
                    href: "javascript:void(0);",
                    onclick: "clearRecentSearchesList();",
                    tabindex: 1
                }).html(autocompleteDefaultSuggestions.recentSearchesClearListLabel)
            );
            $suggestions_ul.append($suggestion_li);
            $suggestions_wrapper.append($suggestions_ul);
        }
    }

    let hasTrendingSuggestions = false;

    // Egc suggestions
    if (autocompleteDefaultSuggestions.suggestionsEGC !== null) {
        $.each(Object.keys(autocompleteDefaultSuggestions.suggestionsEGC.suggestions), function (index, value) {
            buildSuggestionList(autocompleteDefaultSuggestions.suggestionsEGC, $trending_ul, index, value);
            hasTrendingSuggestions = true;
        });
    }

    // Coveo suggestions
    if (autocompleteDefaultSuggestions.suggestionsCoveo !== null && isCoveoEnabled) {
        $.each(Object.keys(autocompleteDefaultSuggestions.suggestionsCoveo.suggestions), function (index, value) {
            buildSuggestionList(autocompleteDefaultSuggestions.suggestionsCoveo, $trending_ul, index, value);
            hasTrendingSuggestions = true;
        });
    }

    if (hasTrendingSuggestions) {
        $suggestions_wrapper.append($trending_header);
        $suggestions_wrapper.append($trending_ul);
    }


    $advise_wrapper.removeClass('hide');
    $suggestions_wrapper.append($advise_wrapper);

    $searchAutocompleteResultDiv.html($suggestions_wrapper);
    $searchAutocompleteResultDiv.append($advise_wrapper);

    if ($.trim($suggestions_wrapper.text()).length > 0 || $.trim($advise_wrapper.text()).length > 2 || TINK.matchMediaMobileTablet()) {
        $searchAutocompleteResultDiv.css('display', 'flex').attr('aria-hidden', false);
    } else {
        $searchAutocompleteResultDiv.css('display', 'none').attr('aria-hidden', true);
    }
}

function clearRecentSearchesList() {
    if (isAuthenticated) {
        $.ajax({
            url: productSearchHistoryUrl,
            type: 'DELETE',
            contentType: 'application/json',
            success: function () {
                showDefaultSuggestions($('#header-search-autocomplete-result'));
            },
            error: function (jqXHR, status, error) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    console.warn('Error while trying to delete product search history for ' + request.term + ' | error=' + error);
                }
            }
        });
    } else {
        localStorage.setItem("recentSearches", "");
        showDefaultSuggestions($('#header-search-autocomplete-result'));
    }

    if(!$(".suggestions__wrapper").children().length && !$autocompleteContainer.hasClass("hide")) {
        $autocompleteContainer.css('display', 'none').attr('aria-hidden', true);
    }
}

function buildSuggestionList(suggestionList, $suggestions_ul, index, value) {
    var liTag = '<li' + (index > 4 ? ' class="d-none d-md-block"' : '') + '/>';
    var $suggestion_li = $(liTag).append(
        $('<a/>', {
            href: suggestionList.suggestions[value],
            tabindex: 1,
            one: {
                click: function () {
                    $(this).css("pointer-events", 'none');
                }
            }
        }).html(value)
    );
    $suggestions_ul.append($suggestion_li);
}

function createAutocompleteSuggestions(textSplitted, suggestions) {
    let autocompleteSuggestionsToAppend = '';
    $.each(suggestions, function (indexSuggestion, suggestion) {
        var suggestionToDisplay = suggestion;
        $.each(textSplitted, function (index, value) {
            if (value.length > 0) {
                suggestionToDisplay = suggestionToDisplay.replace(new RegExp(value, 'gi'), "<<" + value + ">>");
            }
        });
        autocompleteSuggestionsToAppend += '<li tabindex="1" class="one-click"><a href="' + searchProductUrl + encodeURI(suggestion) + '">'
            + suggestionToDisplay.replace(/<</g, '<span class="black">').replace(/>>/g, '</span>') + '</a></li>';
    });
    if (autocompleteSuggestionsToAppend.length) {
        $('.autocompleteSuggestions').append(autocompleteSuggestionsToAppend);
    }
}